export const NikeSVG = () => (
  <svg
    data-testid="nike-logo-svg"
    width={51}
    height={26}
    viewBox="0 0 51 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.07197 15.916C8.67625 15.916 8.36643 16.1928 8.36643 16.5968C8.36643 17.001 8.67785 17.2762 9.07197 17.2762C9.46583 17.2762 9.77751 16.9991 9.77751 16.5968C9.77751 16.1928 9.46742 15.916 9.07197 15.916ZM9.07197 17.0816C8.78981 17.0816 8.58051 16.8755 8.58051 16.5968C8.58051 16.3183 8.78821 16.1106 9.07197 16.1106C9.35227 16.1106 9.56316 16.3215 9.56316 16.5968C9.56316 16.8704 9.35041 17.0816 9.07197 17.0816ZM15.9372 13.5347H12.5026L12.893 7.56494L10.6626 13.5347H7.47314L12.5337 0.0412598H15.9273L15.5356 6.09297L17.8083 0.0412598H20.998L15.9372 13.5347ZM16.3515 13.5347L21.4118 0.0412598H24.6012L19.5409 13.5347H16.3515Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.10524 8.88421C2.64837 14.1182 -1.55586 21.0823 2.15771 24.2893C5.75614 27.397 10.254 25.557 13.3208 24.3302C16.3876 23.1034 50.285 8.38318 50.285 8.38318C50.6121 8.21963 50.5509 8.01512 50.1419 8.11724C49.977 8.15846 13.2391 18.1147 13.2391 18.1147C8.57722 19.4234 3.26163 16.5712 7.10524 8.88421Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.19222 16.6446C9.29115 16.6398 9.36854 16.5887 9.36854 16.4518C9.36854 16.2752 9.25312 16.2308 9.06031 16.2308H8.7832V16.9629H8.96803V16.6512H8.99915L9.16748 16.9629H9.37997L9.19222 16.6446ZM9.07361 16.526H8.9683V16.356H9.05712C9.11164 16.356 9.17413 16.3624 9.17413 16.4334C9.17413 16.5095 9.13797 16.526 9.07361 16.526ZM41.1331 0C40.7374 0 40.4276 0.277108 40.4276 0.680803C40.4276 1.08476 40.7392 1.36001 41.1331 1.36001C41.5269 1.36001 41.8386 1.0829 41.8386 0.680803C41.8389 0.277108 41.5291 0 41.1331 0ZM41.1331 1.16588C40.8509 1.16588 40.6416 0.959774 40.6416 0.68107C40.6416 0.402632 40.8493 0.194933 41.1331 0.194933C41.4134 0.194933 41.6245 0.405823 41.6245 0.68107C41.6245 0.954721 41.4118 1.16588 41.1331 1.16588Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M41.2535 0.728712C41.3525 0.723925 41.4301 0.672865 41.4301 0.535907C41.4301 0.359323 41.3144 0.314911 41.1219 0.314911H40.8448V1.04678H41.0293V0.735361H41.0607L41.2288 1.04678H41.4415L41.2535 0.728712ZM41.1346 0.610103H41.0293V0.440168H41.1184C41.1727 0.440168 41.2354 0.446817 41.2354 0.517823C41.2354 0.593615 41.199 0.610103 41.1346 0.610103ZM39.0316 2.29031L39.8887 0.0412598H30.1569L26.8154 4.08938L28.3581 0.0412598H25.1278L20.1079 13.5347H23.2973L25.4405 7.89205L25.5873 13.5347L35.3736 13.5135L36.3052 10.9179H32.5844L33.807 7.64685H36.8735L37.8171 5.13213H34.7505L35.8018 2.29031H39.0316ZM28.7515 12.6351L28.547 5.60231L33.3692 0.30773L28.7515 12.6351Z"
      fill="black"
    />
  </svg>
)
